import React from 'react';
import {
    withStyles,
    IconButton,
    ListItem,
    ListItemIcon,
    ListItemSecondaryAction,
    Grid,
    Typography,
    ButtonBase,
    Divider,
    List,
    Avatar,
} from '@material-ui/core';

import {
    withRouter,
} from "react-router-dom"

import AppData from '../../model/AppData';
import MBack from '../view/MBack';
import Apis from '../../network/Apis';
import DateUtils from '../../control/dateutils';
import TIMUtils from '../../network/TIMUtils';
import DeviceEventEmitter, { EventName } from '../../control/event';
import AppUtils from '../../control/apputlis';
import ChatItem from './ChatItem';


const SVIP_ICON = require('../../images/change/default_avatar.png');
const ICON_ADD_FRIEND = require('../../images/icons/icon_add_friend.png');

class ChatPage extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            avatar: AppData.me.Pic,
            sysmsg: [],
            conversationList: [],
        }

        console.log('ChatPage', props);
    }

    componentDidMount() {
        AppUtils.YMPush('MAIN', 'ChatPage');
        this.getSystemMessage();
        if (TIMUtils.isReady) {
            this.getConversation();
        }
        DeviceEventEmitter.on(EventName.EVENT_TIM_MESSAGE_RECEIVED, this.onMessageReceived, this);
        DeviceEventEmitter.on(EventName.EVENT_TIM_READY, this.onTimReady, this);
    }

    componentWillUnmount() {
        this.setState = () => false;
        DeviceEventEmitter.off(EventName.EVENT_TIM_MESSAGE_RECEIVED, this.onMessageReceived, this);
        DeviceEventEmitter.off(EventName.EVENT_TIM_READY, this.onTimReady, this);
    }

    onMessageReceived = (event) => {
        if (TIMUtils.PRIMSG.length > 0) {
            this.setState({ showPoint: true });
        }
    }

    onTimReady = () => {
        this.getConversation();
    }

    getSystemMessage = async () => {
        let result = await Apis.encryptionSystemMessage();
        console.log('getSystemMessage', result);
        if (result.code == 200) {
            this.setState({ sysmsg: result.data });
        }
    }

    getConversation = async () => {
        let result = await TIMUtils.getConversationList();
        console.log('getConversation', result);
        if (result && result.code == 0 && result.data && result.data.conversationList) {
            let conversationList = result.data.conversationList.filter((item) => {
                return (item.userProfile != null && item.userProfile != undefined) || (item.groupProfile != null && item.groupProfile != undefined);
            })
            this.setState({ conversationList: conversationList })
        }
    }

    _onListItemClick = (data) => {
        if (data && data.userProfile) {
            let nick = data.userProfile.nick;
            let userId = data.userProfile.userID;
            this.props.history.push({ pathname: '/privateletter/' + userId + '/userProfile', data: nick });
        } else if (data && data.groupProfile) {
            let nick = data.groupProfile.name;
            let userId = data.groupProfile.groupID;
            this.props.history.push({ pathname: '/privateletter/' + userId + '/groupProfile', data: nick });
        }
    }

    _onClickSysMsg = () => {
        console.log('_onClickSysMsg');
        const { sysmsg } = this.state;
        this.props.history.push({ pathname: '/sysmessage/', data: sysmsg });
    }

    _onSearchFriend = () => {
        const { sysmsg } = this.state;
        this.props.history.push({ pathname: '/chatsearchfriend/', data: sysmsg });
    }

    onChatBookClick = () => {
        this.props.history.push({ pathname: '/chatbook/' });
    }

    onQunliao = () => {
        this.props.history.push({ pathname: '/chatgroup/' });
    }

    onAddNewFriend = () => {
        this.props.history.push({ pathname: '/chataddfriend/' });
    }

    renderItem = (data, n) => {
        const { classes } = this.props;
        let showPoint = data.unreadCount > 0;
        // for (let i = 0; i < TIMUtils.PRIMSG.length; i++) {
        //     if (data.userProfile) {
        //         if (TIMUtils.PRIMSG[i].from == data.userProfile.userID) {
        //             showPoint = true;
        //         }
        //     } else if (data.groupProfile) {
        //         if (TIMUtils.PRIMSG[i].from == data.groupProfile.groupID) {
        //             showPoint = true;
        //         }
        //     }
        // }

        let nick = '';
        if (data && data.userProfile) {
            nick = data.userProfile.nick;
        } else if (data && data.groupProfile) {
            nick = data.groupProfile.name;
        }
        return (
            <ListItem key={n + ''} disableRipple button onClick={() => this._onListItemClick(data)} style={{ paddingLeft: 8, paddingRight: 8, margin: 0 }}>
                <Grid container direction='row' alignItems="center" justify='space-between'>
                    <Grid container direction='row' style={{ flex: 1 }}>
                        <Grid container direction='row' style={{ alignItems: 'flex-start', width: 46 }}>
                            <Avatar src={data.userProfile && data.userProfile.avatar} className={classes.menuIcon} />
                            {
                                showPoint && <Grid style={{ backgroundColor: '#FC3035', marginLeft: 0, marginBottom: 4, width: 6, height: 6, borderRadius: 3 }} />
                            }
                        </Grid>
                        <Grid style={{ alignItems: 'flex-start', maxWidth: '50%', marginLeft: 6 }}>
                            <Typography style={{ color: '#0D0D0D', fontSize: 14 }}>{nick}</Typography>
                            <Typography noWrap className={classes.contents} style={{ width: 200 }}>{data.lastMessage && data.lastMessage.payload && data.lastMessage.payload.text}</Typography>
                        </Grid>
                    </Grid>
                    <Grid container direction='row' justify='flex-end' style={{ maxWidth: 96 }}>
                        <Typography className={classes.contents} style={{ marginLeft: 20 }}>{data.lastMessage && DateUtils.dateFormat1(data.lastMessage.lastTime)}</Typography>
                    </Grid>
                </Grid>
            </ListItem>
        );
    }

    render() {
        const { classes } = this.props;
        const { conversationList, sysmsg } = this.state;
        let content = '';
        if (sysmsg.length > 0) {
            content = sysmsg[0].content;
        }
        let title = '消息';
        let hideBack = true;
        if (AppData.ServerConfig && AppData.ServerConfig.tap_show == 1) {
            title = '我的通讯';
            hideBack = false;
        }


        let is_has_add_friend = true;
        if (AppData.ServerConfig) {
            is_has_add_friend = AppData.ServerConfig.is_has_add_friend
        }


        return (
            <MBack title={title} hideBack={hideBack}>
                <Grid style={{ height: 16 }}></Grid>
                <Grid container justify='flex-start'>
                    {
                        sysmsg.length > 0 && <Typography className={classes.tittle}>官方通知</Typography>
                    }
                    {
                        sysmsg[0] && <ListItem disableRipple button onClick={() => this._onClickSysMsg()} style={{ paddingLeft: 8, paddingRight: 8, margin: 0 }}>
                            <Grid container direction='row' alignItems="center" justify='space-between'>
                                <Grid container direction='row' style={{ flex: 1 }}>
                                    <img src={SVIP_ICON} alt='' className={classes.menuIcon} />
                                    <Grid style={{ alignItems: 'flex-start', maxWidth: '50%' }}>
                                        <Typography style={{ color: '#0D0D0D', fontSize: 14, marginLeft: 10 }}>{sysmsg[0] ? sysmsg[0].title : ''}</Typography>
                                        <Typography noWrap className={classes.contents} style={{ width: 200, marginLeft: 10 }}>{sysmsg[0] ? sysmsg[0].content : ''}</Typography>
                                    </Grid>
                                </Grid>
                                <Grid container direction='row' justify='flex-end' style={{ maxWidth: 96 }}>
                                    <Typography className={classes.contents} style={{ marginLeft: 20 }}>{sysmsg[0] ? DateUtils.dateFormatMDNoWeek(sysmsg[0].addTime) : ''}</Typography>
                                </Grid>
                            </Grid>
                        </ListItem>
                    }
                </Grid>
                {
                    sysmsg.length > 0 && <Grid container justify='center'>
                        <Divider light style={{ background: '#FAFAFA', width: '100%', justifyContent: 'center' }} />
                    </Grid>
                }
                <Grid container style={{ height: 10 }}></Grid>
                {
                    conversationList.length > 0 && <Typography className={classes.tittle}>聊天信息</Typography>
                }
                <Grid container justify='flex-start' >
                    <List style={{ width: '100%' }}>
                        {
                            conversationList.map((data, n) => (
                                this.renderItem(data, n)
                            ))
                        }
                    </List>
                </Grid>
            </MBack>
        );
    }
}

export default withRouter(withStyles((theme) => ({
    tittle: {
        color: '#0D0D0D',
        padding: theme.spacing(0, 2),
        fontSize: 14,
    },
    contents: {
        color: '#878787',
        fontSize: 12,
    },
    menuIcon: {
        color: theme.palette.secondary,
        margin: theme.spacing(0),
        width: 40,
        height: 40,
    },
    divider: {
        width: '100vw',
        height: 10,
        backgroundColor: '#FAFAFA',
        margin: theme.spacing(1, 0, 1, 0),
    }


}))(ChatPage));